import React from 'react';
import { fetchUser } from "../actions/index";
import { connect } from 'react-redux'

class AccessForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleHexChange = this.handleHexChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear= this.handleClear.bind(this);
    this.handleErrorClose = this.handleErrorClose.bind(this);
  }

  componentWillMount() {
    this.state = {
      email: '',
      hex: ''
    }
  }

  handleErrorClose() {
  }

  handleClear() {
    this.setState({ email: '', hex: '' });
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value});
  }

  handleHexChange(event) {
    this.setState({ hex: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault()
    const { fetchUser } = this.props
    fetchUser(this.state.email, this.state.hex)
  }

  handleCheckboxChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    })
  }

  render() {
    const { error, is_whitelisted, request } = this.props
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="FormGroup">
          <div className={is_whitelisted ? 'FormField disabled' : 'FormField'}>
            <input type="email"
                   className="FormInput email"
                   name="input-email"
                   value={this.state.email}
                   placeholder="Email"
                   onChange={this.handleEmailChange} />
          </div>
          <div className={is_whitelisted ? 'FormField disabled' : 'FormField'}>
            <input type="text"
                   className="FormInput hex"
                   name="input-hex"
                   value={this.state.hex}
                   placeholder="Your Ethereum Address"
                   onChange={this.handleHexChange} />
          </div>
        </div>

        <div className="FormGroup">
          <div className="suggestion">
            <ul>
              <li>Enter your ERC20 compatible ethereum address</li>
              <li>We suggest using MyEtherWallet as it is compatible with ENS and ERC20 tokens</li>
              <li>Do not use an exchange address!</li>
              <li>We are using the ethereum name service address indorse.eth, do not trust any other address posted</li>
            </ul>
          </div>
        </div>

        <div className="FormGroup">
          {/*<input className="FormButton" type="submit" value="I Agree. I'm ready to contribute" />*/}
          <button className={request ? 'FormButton lock' : 'FormButton'} type="submit"
                  name="submitButton"
                  value="I Agree. I'm ready to contribute" disabled={request}>
            <span>I have entered the correct email, and ETH address</span>
          </button>
        </div>

        { error !== ""
          ? <div className="FormError">{error}<span className="pull-right" onClick={this.handleErrorClose}>x</span></div>
          : '' }
      </form>
    );
  }
}

const mapStateToProps = state => {
  const { registrations } = state
  const { error, request } = registrations
  return { error, request }
}

export default connect(
  mapStateToProps,
  { fetchUser }
)(AccessForm)


// WEBPACK FOOTER //
// ./src/components/AccessForm.jsx